import "../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthContext';
import { PedidosContext } from '../../../context/pedidos/PedidosContext';
import { PedidosDetalleContext } from '../../../context/pedidosdetalle/PedidosDetalleContext';
import { Paginator } from '../../../components/paginator/Paginator';
import { getHeaders } from "./configGrid/headers";
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../components/DataGrid/indice";
import { getActionColumn } from "../../../components/ActionesColumns/ActionColumns";
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from "../../../components/Title";
import CustomDataGrid from "../../../components/DataGrid/CustomDataGrid";
import ConfirmDialog from "../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { useFilters } from "../../../context/FiltersContext";
import ComprobantePDF from "../../../components/Imprimir/ComprobantePDF";
import { formatHeaderPDF } from "./configPDF/headerPDF";
import { columns } from "./configPDF/columnsPDF";
import { formatRowsPDF } from "./configPDF/rowsPDF";

export const Datatable = () => {
  const titleGrid = "Lista de Pedidos"
  useDocumentTitle(titleGrid);
  const { updateFilters, getFilters } = useFilters();
  const contexto = useContext(PedidosContext);
  const { getPedidosPanelData, deletePedidosData } = contexto;
  const { getPedidosDetallePanelData } = useContext(PedidosDetalleContext);
  const { empresaData } = useContext(AuthContext);
  const navigate = useNavigate();
  const nameData = "pedidos";
  const getData = getPedidosPanelData;
  const deleteData = deletePedidosData;
  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchIDCli, setSearchIDCli] = useState();
  const [searchDescCli, setSearchDescCli] = useState({});
  const [searchIDEmp, setSearchIDEmp] = useState();
  const [searchDescEmp, setSearchDescEmp] = useState({});
  // Ref para busqueda
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el Modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  // Estado para crear el pdf
  const [headerPDF, setHeaderPDF] = useState();
  const [columnsPDF, setColumsPDF] = useState();
  const [rowsPDF, setRowsPDF] = useState();
  const [pdfReady, setPdfReady] = useState(false);
  //Estado General de Filtros en LocalStorage
  const [isInitialized, setIsInitialized] = useState(false);
  const pageKey = "pedidos";
  // 🔹 Obtenemos los filtros persistidos
  const filters = getFilters(pageKey) || {
    searchIDCli: "",
    searchDescCli: "",
    searchIDEmp: "",
    searchDescEmp: ""
  };

  useEffect(() => {
    const savedFilters = getFilters(pageKey);

    if (savedFilters) {
      setSearchIDCli(savedFilters.searchIDCli || "");
      setSearchDescCli(savedFilters.searchDescCli || "");
      setSearchIDEmp(savedFilters.searchIDEmp || "");
      setSearchDescEmp(savedFilters.searchDescEmp || "");
      setNumPagina(1);
    }

    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isInitialized) return;
    fetchData();
    loadFilters();
  }, [isInitialized, searchIDCli, searchIDEmp, numPagina, filas]);

  // 🔹 Función segura para actualizar filtros
  const loadFilters = () => {
    const updatedFilters = {
      searchIDCli,
      searchDescCli,
      searchIDEmp,
      searchDescEmp
    };
    updateFilters(pageKey, updatedFilters);
  };

  // Dentro del componente `Datatable`
  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems, totalPage } = await fetchEntityData(
        getData,
        searchIDCli || "",
        searchIDEmp || "",
        numPagina,
        filas
      );
      if (numPagina > totalPage) {
        setNumPagina(totalPage);
      } else {
        setListaItems(dataEntity);
        console.log("lsita", listaItems)
        setTotalItems(totalItems);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleDelete = async () => {
    try {
      await deleteItem(deleteData, selectedItem);
      fetchData(); // Refresca los datos
      closeModal(); // Cierra el modal de confirmación
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };

  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const handleClickEdit = (e) => {
    if (e) navigate(`/${nameData}/new/${e}`);
  };

  const getDynamicValue = (row, key) => {
    return row[key];
  };

  const handleRowClick = (params) => {

  };

  const handleCreatePDF = async (cabecera) => {
    try {
      // 🔥 Limpio el PDF anterior para evitar re-render automáticos
      setHeaderPDF(null);
      setColumsPDF([]);
      setRowsPDF([]);

      // Traer detalle por pedido
      const data = await getPedidosDetallePanelData(
        cabecera.id,
        null,
        1,
        9999
      );

      const detalle = data?.orderCacheDetails || [];

      // 🔥 1 - SETEO CABECERA
      setHeaderPDF(formatHeaderPDF(cabecera));

      // 🔥 2 - SETEO COLUMNAS PARA PDF
      setColumsPDF(columns);

      // 🔥 3 - SETEO FILAS PARA PDF YA FORMATEADAS
      setRowsPDF(formatRowsPDF(detalle));
      setPdfReady(true);

    } catch (err) {
    }
  };
  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(getHeaders(handleCreatePDF).filter((column) => !column.hidden));
    return commonCols.concat(getActionColumn(handleClickEdit, openModal));
  }, [numPagina, filas]);

  const rows = useMemo(() => formatRows(listaItems), [listaItems]);

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <h3>{titleGrid}</h3>
        <FiltersGrid
          setSearchIDFilter={setSearchIDCli}
          setSearchDescFilter={setSearchDescCli}
          setSearchSecondIDFilter={setSearchIDEmp}
          setSearchSecondDescFilter={setSearchDescEmp}
        />
      </div>
      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          <div className="datagridWrapper">
            <CustomDataGrid
              rows={rows}
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems}
              onRowClick={handleRowClick}
              onPageChange={setNumPagina}
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);
              }}
              isLoading={isLoading}
            />
          </div>
          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>
          <ConfirmDialog
            open={isModalOpen}
            onClose={closeModal}
            onConfirm={handleDelete}
            nameData={nameData}
          />

          <ErrorDialog
            open={isErrorDialogOpen}
            onClose={closeErrorDialog}
            errormessages={errorMessage}
          />
          <ComprobantePDF
            header={headerPDF}
            columns={columnsPDF}
            rows={rowsPDF}
            titlePdf="Pedido"
            empresa={empresaData}
            trigger={pdfReady}
            onFinish={() => setPdfReady(false)}
          />

        </>

      )}
    </div>
  );
};

export default Datatable;
